import { useCallback } from 'react';

/**
 * Returns a callback ref that will map it's argument
 * and set the given targetRef with the result.
 * @param targetRef Ref to assign mapped result to
 * @param map Function to map given ref value to another value
 */
export function useMappedRef(targetRef, map) {
  return useCallback(ref => {
    if (typeof targetRef === 'function') {
      targetRef(map(ref));
    } else {
      // eslint-disable-next-line no-param-reassign
      targetRef.current = map(ref);
    }
  }, [map, targetRef]);
}
export default useMappedRef;
//# sourceMappingURL=useMappedRef.js.map